'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    try {
        processInclude(require('./search/search'));
    } catch (ex) {
        console.log('Error at search script: ' + ex);
    }

    // PIK202006-32 - 201217 - Change sort-order select to ul
    try {
        processInclude(require('./search/sortOrder'));
    } catch (ex) {
        console.log('Error at search script: ' + ex);
    }

    try {
        processInclude(require('./product/quickView'));
    } catch (ex) {
        console.log('Error at search script: ' + ex);
    }
});
